import { render } from "./ReportCategorySales.vue?vue&type=template&id=38c44207&scoped=true"
import script from "./ReportCategorySales.vue?vue&type=script&lang=js"
export * from "./ReportCategorySales.vue?vue&type=script&lang=js"

import "./ReportCategorySales.vue?vue&type=style&index=0&id=38c44207&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c44207"]])

export default __exports__